import React from 'react';

import messages from '../messages';
import { PlusIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Button } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { TableHeader } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import useIntl from '../../../hooks/useIntl';

const RentForecastHeader = (props) => {
  const { count, openRentForecastModal, totalCount, disableButtonModal } =
    props;
  const intl = useIntl();

  return (
    <TableHeader
      title={intl.formatMessage(messages.title)}
      actions={[
        <Button
          key={2}
          onClick={openRentForecastModal}
          variant="shout"
          disabled={disableButtonModal}
          startIcon={<PlusIcon />}
        >
          {intl.formatMessage(messages.createRentForecast)}
        </Button>,
      ]}
      count={count}
      totalCount={totalCount}
    />
  );
};

export default RentForecastHeader;
